
(function () {
  'use strict';
  angular.module('irricrops')
    .factory('IrriviewFac', ['Config', '$timeout', function (Config, $timeout) {

      //---------------------------------------
      //--------- PRIVATE VARIABLES -----------
      //---------------------------------------

      var notes             = [];
      var limitsLine        = 4;
      var draggingId        = 0;
      var lastDragging      = 0;
      var chart             = null
      var relativePositions = [];
      var redrawEvent       = null;
      var loadEvent         = null;
      var legendItemClick   = null;
      var rulerDateFormat   = "DD/MM dddd HH:mm";

      var ID_ELEMENT        = null;
      var withNotes         = true;
      var class_subelement = ".canvas";
      var SETTING_EXTREMES  = false;


      //---------------------------------------
      //--------- PRIVATE FUNCTIONS -----------
      //---------------------------------------



      var debounceSetExtremes = _.debounce(function(){
        addEventsLines(this.chart);
        reloadExNotes(this.chart);
        if(!SETTING_EXTREMES){
          console.log("set extremes");
          SETTING_EXTREMES = true;
          $("#"+ID_ELEMENT).find(class_subelement).addClass("hide-serie-label");
        }
      },0);

      var debounceAfterSetExtremes = _.debounce(function(){
        if(SETTING_EXTREMES){
          console.log("after set extremes");
          SETTING_EXTREMES = false;
          $("#"+ID_ELEMENT).find(class_subelement).removeClass("hide-serie-label");
        }
      }, 1000);


      var setExtremes = function (e) {
        debounceSetExtremes.bind(this)(e);
      }

      var afterSetExtremes = function(e){
        debounceAfterSetExtremes.bind(this)(e);
      }

      function ArrayHasData (arr) {
        var hasData = false;
        if(arr !== undefined && arr.length > 0){
          angular.forEach(arr, function(item) {
            if(typeof item === 'object'){
              if(item[1] !== null && !isNaN(item[1])){
                hasData = true;
              }
            } else if(item !== null && !isNaN(item)){
              hasData = true;
            }
          });
        }
        return hasData;
      }


      var debounceRedraw = _.debounce(function(e){
        if(redrawEvent !== null){
          redrawEvent.bind(this)(e);
        }
      }, 200);

      var redrawEvent = function (e) {
        debounceRedraw.bind(this)(e);
      }


      function getYValue(serie,xValue){
        var yValue = null;
        var points = serie.points;
        for(var i=0;i<points.length;i++){
          if(points[i].x>=xValue)break;
          yValue=points[i].y;
        }
        return yValue;
      }


      var getLines = function(chart){
        var plr = []; // plot lines return
        if(chart.xAxis.length > 0){
          var  plines = chart.xAxis[0].plotLinesAndBands || [];
          _.each(plines, function(pl){
            if(pl.options.ruler){
              plr.push(pl);
            }
          });
        }
        return plr;
      }


        var addRuler = function(params){
          var lines = getLines(params.chart);
          if(lines.length >= limitsLine){
            return;
          }

          var xValue    = params.value;// evt.xAxis[0].value;
          var xAxis     = params.chart.xAxis[0];
          var id        = params.lineId || _.random(10, 100000);
          var m         = moment(xValue);
          var labelText = "<span class='date'>" + moment(xValue).utc().format(rulerDateFormat) + "</span>";
          var closebtn  = "<button class='remove-line' data-id='"+id+"'>"+
                          " <i class='material-icons'>&#xE5CD;</i> </button>";

          var line = xAxis.addPlotLine({
            value  : xValue,
            color  : 'red',
            width  : 2,
            id     : id,
            ruler  : true,
            zIndex : 1,
            label  : {
              useHTML       : true,
              text          : labelText + closebtn,
              originalText  : labelText + closebtn,
              verticalAlign : 'top',
              textAlign     : 'center',
              rotation      : 0,
              y             : -10,
              className     : "plotline-ruler"
            }
          });
          addEventsLines(params.chart);
          reloadExNotes(params.chart);
        }


      var addEventsLines = function(chart){
        var lines = getLines(chart);

        Highcharts.each(lines, function(line){
          if(line.svgElem.translateX === undefined){
            line.svgElem.translate(0, 0);
          }
          if(line.label !== null && line.label !== undefined){

            $(line.label.element).find("span.date")
              .unbind(".line");

            $(line.label.element).find("span.date")
              .on('mousedown.line', function(e){

                var lines    = getLinesById(line.id, chart);
                var x        = e.pageX - line.svgElem.translateX;
                draggingId   = line.id;
                lastDragging = line.id;

                $(document).bind({
                  'mousemove.line': function(e){
                    step(e, line,x);
                  }
                });

              }).on('mouseup.line', function(e){
                if(draggingId !== null){
                  stop(e, chart);
                }
              });


            $(line.label.element)
              .find("button.remove-line")
              .on("click.line", function(e){
                e.preventDefault();
                e.stopImmediatePropagation();
                removeLinesById(parseInt(this.dataset.id), chart);
              });
          }
        });
      }


      var getLinesById = function(id, chart){
        var linesReturn = [];
        var lines = getLines(chart);
        for (var x = 0; x < lines.length; ++x) {
          var line = lines[x];
          if(line.id == id){
            linesReturn.push(line);
          }
        }
        return linesReturn;
      }

        var removeLinesById = function(id, chart){
          var id = parseInt(id);
          chart.xAxis[0].removePlotLine(id);
          reloadExNotes(chart);
        }



        var refreshExNotes = function(notes){

          var annLast = {};
          //ordenado por el valor X de la primera nota de cada linea
          //PD, annotations es un array de linea de anotaciones, que contiene anotaciones
          // las anotaciones de cada linea comparten el mismo xValue
          notes.sort(function(a,b){
            return a.chartIndex - b.chartIndex || a.x - b.x;
          });

          _.each(notes, function(note){//lineas
            note.text.splice(0, note.text.length);
          });

          angular.forEach(notes, function(note){//lineas
            _.each(note.chart.series, function(serie, i){
              var chart = note.chart;

              if(serie.visible &&
                serie.userOptions.ruler !== undefined &&
                serie.userOptions.group !== "nav" &&
                serie.userOptions.ruler.enabled){ //TODO verificar esto

                var serieId = serie.options.id;
                var color   = serie.color;
                var icon    = "<div class='icon-ann' style='background: "+color+"'></div>";
                var abbr    = serie.options.abbr ?  serie.options.abbr : serie.options.name;
                abbr        = '<span class="abbr">'+abbr+'</span>'

                //si es la primera nota
                if(annLast[serieId] == undefined){
                  var value = getYValue(serie, note.xValue);
                  if(value ==  null){
                    value = "--";
                    note.value = 0;
                  }else{
                    value = _.round(value, 2);
                    note.value = value;
                  }

                  note.text.push({
                    text: icon + abbr + value
                  });
                  annLast[serieId] = {value:value, xValue:note.xValue};
                  return; // pasa al siguiente paso del bucle
                }else{
                  //si no es la primera

                  var sum = 0;
                  var init = null;
                  var end = null;


                  _.each(serie.yData, function(datoY, k){
                    if(datoY !== undefined){
                      var datoX = serie.xData[k];
                      //comparar unix, para comenzar desde el dia de
                      //la nota anterior, pero antes de la actual

                      if(datoY !== null){
                        if(datoX >= annLast[serieId].xValue &&
                          datoX < note.xValue &&
                          _.isFinite(datoY)){
                          sum += datoY;
                        }
                      }
                    }
                  });


                  if(end == null){
                    end = 0;
                  }

                  if(init == null){
                    init = 0;
                  }

                  var value = getYValue(serie, note.xValue);
                  if(value ==  null){
                    value = "--";
                    note.value = 0;
                  }else{
                    value = _.round(value, 2);
                    note.value = value;
                  }


                  var diff = "--";
                  if(_.isNumber(value) && _.isNumber(annLast[serieId].value)){
                    var diff = _.round( value - annLast[serieId].value, 2);
                  }

                  var text = icon + abbr +
                    " <span class='value'> "+ value +"</span> ";

                  if(serie.userOptions.ruler.sum){
                    text += " <span class='sum'> <b>Σ</b>: "+_.round(sum, 2) + "</span>";
                  }
                  if(serie.userOptions.ruler.delta){
                    text += " <span class='delta'> <b>∆</b>: "+ diff+ "</span>";
                  }

                  note.text.push({
                    text : text
                  });
                  //annLast[serieId] = note;
                  annLast[serieId] = {value:value, xValue:note.xValue};

                } // if last
              } // if chart == chart
            });
          });

          return notes;

        }










        var reloadExNotes = function(chart){

          notes = [];
          var lines = getLines(chart);
          angular.forEach(lines, function(line){
            var x       = line.axis.toPixels(line.options.value);
            var visible = true;
            var oposite = false;
            var date    = moment(line.options.value).format("DD-MM-YYYY");

            if(line.options.value > line.axis.max || line.options.value < line.axis.min){
              visible =  false;
            }

            if(line.options.value > (line.axis.min + ((line.axis.max - line.axis.min)/2)) ){
              oposite = true;
            }


            notes.push({
              a          : moment(line.options.value).format(),
              chartIndex : chart.index,
              chart      : chart,
              x          : x,
              xValue     : line.options.value,
              id         : line.options.id,
              line       : line,
              text       : [],
              visible    : visible,
              oposite    : oposite
            });
          });

          $("#"+ID_ELEMENT).find(".ex-note").remove();

          refreshExNotes(notes);


          _.each(notes, function(note){
            if(note.visible){
              var div = $("<div>").addClass("ex-note");

              if(note.id == lastDragging){
                div.css({
                  'z-index': 3
                });
              }

              div.on("click", function(){
                $("#"+ID_ELEMENT).find(".ex-note").css({
                  'z-index': ""
                });
                $(this).css({
                  'z-index': 3
                });
              }).css({
                  left: (note.x - 30)
              });

              var title = $("<span>").addClass("title")
                .html(moment(note.xValue).format("DD/MM HH:mm"));
              div.append(title);

              _.each(note.text, function(t){
                var item = $("<span>").addClass("serie").html(t.text);
                div.append(item);
              });

              note.div = div;
              $("#notes").append(div);

              if(note.oposite){
                div.addClass("oposite");
                div.css({
                  left: note.x - div.width() + 20
                });
              }

            }
          });

        }










        var stop = function (e, chart) {
          $(document).unbind('.line'); //delete namespace events
          var line = getLinesById(draggingId, chart)[0];
          if(line){
            var dato = line.axis.toValue(line.axis.toPixels(line.options.value) + line.svgElem.translateX);
            removeLinesById(draggingId, chart);
            addRuler({value:dato, lineId: draggingId, chart: chart});
            reloadExNotes(chart);
          }
          draggingId = null;
        }


        var step = function (e, line, x) {
          var dato = line.axis.toValue(line.axis.toPixels(line.options.value) + line.svgElem.translateX);
          var moveX = e.pageX - x;
          if(dato < line.axis.min && moveX < line.svgElem.translateX ){
            moveX = line.svgElem.translateX;
          }

          if(dato > line.axis.max && moveX > line.svgElem.translateX ){
            moveX = line.svgElem.translateX;
          }

          line.svgElem.translate(moveX, 0);
          if(line.label !== null && line.label !== undefined){
            $(line.label.element).css({"transform": "translateX("+moveX+"px)"});
            var m = moment(dato);
            var labelText = "<span class='date'>" + moment(dato).utc().format(rulerDateFormat) + "</span>";
            var closebtn = "<button class='remove-line' data-id='"+line.id+"'> <i class='material-icons'>&#xE5CD;</i> </button>";
            line.label.textSetter(labelText + closebtn);
            line.options.label.originalText = labelText;
          }
        }









      var config = {

        chart:{

          panning       : false,
          marginTop     : 50,
          marginLeft    : 30,
          marginRight   : 30,
          //marginBottom  : 60,
          spacingTop    : 20,
          spacingLeft   : 0,
          spacingRight  : 0,
          //spacingBottom : 10,

          backgroundColor :  "white",

          zoomType: "x",

          events:{
            click: function(e){
              if (withNotes) {
                e.preventDefault();
                e.stopImmediatePropagation();
                addRuler({chart:this, value:e.xAxis[0].value});
              }
            },
            load:function(e){
              if(loadEvent){
                loadEvent.bind(this)(e);
              }
            },
            redraw: redrawEvent
          }
        },



        navigator:{
          handles: {
            backgroundColor: '#81c784',
            borderColor: '#1b5e20'
          },
          series:{
            label:{
              enabled:false,
              connectorNeighbourDistance: 12,
            }
          },
        },




        responsive:{
          rules:[{
            condition: {
              maxWidth: 500
            },
            chartOptions:{

              chart:{
                panning       : false,
                marginTop     : 50,
                marginLeft    : 10,
                marginRight   : 30,
                //marginBottom  :undefined,
                spacingTop    : 20,
                spacingLeft   : 0,
                spacingRight  : 0,
                //spacingBottom : undefined
              },

              rangeSelector:{
                enabled: false
              }
            }
          }]
        },

        exporting:{
          sourceWidth   : 1200,
          sourceHeight  : 700,
          printMaxWidth : 1200,
          scale         : 2,
          enabled       : true,
          buttons       : {
            customButton:{
              x          : -170,
              y          : -3,
              width      : 24,
              height     : 24,
              symbol     : "download",
              symbolX    : 13,
              symbolY    : 13,
              symbolFill : "#546e7a",
              onclick    : function () {
                var filename = "grafico - "+this.userOptions.title.text;
                this.exportChart({
                  filename: filename
                });
              }
            },
            contextButton: {
              enabled : false,
              //https://stackoverflow.com/questions/25232921/disable-pdf-and-svg-download-options-in-highcharts
              menuItems: [{
                textKey : 'downloadPNG',
                onclick : function () {
                  this.exportChart();
                }
              }, ]

            }
          },
        },

        credits: {
          text:"irricrops.com",
          href:"https:://irricrops.com"
        },

        legend:{
          enabled: true,
        },

        title: {},
        subtitle: {},

        tooltip: {
          split         : false,
          valueDecimals : 2,
          shared        : false,
          useHTML       : true,
          //crosshairs: true
        },

        plotOptions:{
          series: {
            connectNulls: true,
            events: {
              // mouseOver: function () {
              //   console.log("in");
              // },
              // mouseOut: function () {
              //   console.log("out");
              // },
              legendItemClick: function(e){
                this.visible = !this.visible;
                reloadExNotes(this);
                if(legendItemClick !== null){
                  legendItemClick.bind(this)(e);
                }
                this.visible = !this.visible;
              }
            }
          }
        },

        rangeSelector: {
          verticalAlign     : "top",
          allButtonsEnabled : true,
          x                 : 0,
          y                 : -70,
          floating          : true,
          inputEnabled      : false,
          buttons     : [{
            type      : 'month',
            count     : 1,
            text      : '1m'
          }, {
            type      : 'month',
            count     : 3,
            text      : '3m'
          }, {
            type      : 'month',
            count     : 6,
            text      : '6m'
          },
          {
            type      : 'all',
            text      : 'Todo'
          }],
          buttonTheme : {
            width : 60
          },
          selected : 3
        },
        xAxis: {
          type          : 'datetime',
          ordinal       : false,
          gridLineColor : "rgba(38,50,56,0.2)",
          gridLineWidth : 1,
          events:{
            setExtremes      : setExtremes,
            afterSetExtremes : afterSetExtremes
          }
        },
        yAxis: [],
        series: []
      };










      function Irriview(options){
        this.config = angular.copy(config);
        this.config.title.text = options.title;
        this.config.subtitle.text = options.subtitle;
        if(options.tooltip){
          this.config.tooltip = options.tooltip;
        }
        if(options.withNotes !== undefined){
          withNotes = options.withNotes;
        }
        if(options.rangeSelected){
          this.config.rangeSelector.selected = options.rangeSelected;
        }

        loadEvent       = null;
        redrawEvent     = null;
        legendItemClick = null;

        if(options.events){
          if(options.events.load){
            loadEvent = options.events.load;
          }
          if(options.events.redraw){
            redrawEvent = options.events.redraw;
          }
          if(options.events.legendItemClick){
            legendItemClick = options.events.legendItemClick;
          }
        }
      }

      var getConfig = function(){
        return this.config;
      }

      var reloadPositions = function(chartOptions){
        var yAxis = chartOptions.yAxis;
        var diff = 0
        relativePositions = [];
        _.each(yAxis, function(y, i){
          var top = angular.copy(y.top)

          //y.top inicia como "0%", pero luego se recalcula
          //igualandose con chart.plotTop
          if(i == 0 && chart !== null && top == chart.plotTop){
            diff = chart.plotTop;
          }
          if(_.isNumber(top)){
            top -= diff;
          }

          if(relativePositions[y.position] == undefined){
            relativePositions[y.position] = {
              top      : top,
              height   : y.height,
              position : y.position, //for debugging
              yaxis    : []
            };
          }
          if(y.stackeable){
            relativePositions[y.position].stackeable = true;
          }
          relativePositions[y.position].yaxis.push(y);
        });
        return relativePositions;
      }

      var getRelativePositions = function(){
        //copy para pasar por valor, no referencia
        return angular.copy(reloadPositions(this.config));
      }

      var expandChart = function(position){
        var top        = this.plotTop;
        var h          = this.plotHeight;
        var lastHeight = 0;

        _.each(relativePositions, function(p, i){
          if(position == null){
            lastHeight = h / relativePositions.length;
          }else if(i != position){
            lastHeight = h * 0.1;
          }else{
            lastHeight = h * (1 - (0.1 * (relativePositions.length - 1)));
          }
          p.height = lastHeight;
          p.top = top;
          top += lastHeight;
        });
        _.each(chart.yAxis, function(y, i){
          var p = y.userOptions.position;
          if(p != undefined){
            y.update({
              top    : relativePositions[p].top,
              height : relativePositions[p].height,
            }, false);
          }
        });
        chart.redraw();
      }



      var getPrev = function(y, positions){
        var r = [];
        _.each(positions[y.position], function(yp){
          if(y.id !== yp.id){
            r.push(yp.id);
          }
        });
        return r;
      }


      var getNext = function(y, positions){
        var r = [];
        if(positions[y.position + 1] == undefined){
          return [];
        }
        _.each(positions[y.position + 1], function(yp){
          if(y.id !== yp.id){
            r.push(yp.id);
          }
        });
        return r;
      }



      var positionYaxis = function(yaxis_array){
        //ultimo eje no lleva resize
        //top
        //height
        var positions = [];

        _.each(yaxis_array, function(y, i){
          if(positions[y.position] == undefined){
            positions[y.position] = [];
          }
          y.realIndex = i;
          positions[y.position].push(y);
        });

        var cant = positions.length;
        var height = 100 / cant;

        _.each(yaxis_array, function(y, i){
          y.height      = height + "%";
          y.top         = (height * (y.position))+ "%";
          y.resize.controlledAxis.prev = getPrev(y, positions);
          y.resize.controlledAxis.next = getNext(y, positions);

          if(i  == yaxis_array.length - 1){
            //y.resize.enabled = false;
          }else{
            y.resize.enabled = true;
          }
        });
        // console.dir(positions);
      }

      var addYAxis = function(yaxis){
        var axis = {
          //id: this.config.yAxis.length + "",
          id: _.random(10000, 99999) + "",
          lineWidth : 2,
          offset    : 0,
          position  : yaxis.position,
          visible   : yaxis.visible !== undefined ? yaxis.visible : true,
          plotLines : [],
          plotBands : [],
          labels    : {
            align : 'right',
            x     : -5
          },
          title     : {
            text : yaxis.text
          },
          resize    : {
            enabled        : true,
            lineWidth      : 2,
            controlledAxis : {
              prev:[],
              next:[]
            }
          }
        };

        if(yaxis.opposite){
          axis.labels.x     = 5;
          axis.labels.align = "left";
          axis.opposite     = false;// default true// right side
        }

        if(yaxis.max){
          axis.min = yaxis.min;
        }
        if(yaxis.max){
          axis.max = yaxis.max;
        }

        if(yaxis.stackeable &&
          yaxis.stackeable.enabled){
          axis.stackeable = yaxis.stackeable;
        }

        if(yaxis.background !== undefined){
          axis.plotBands.push(
            {
              from: -100000000000,
              to: 100000000000,
              color: yaxis.background
            }
          );
        }
        if(this.config.yAxis.length == 0){
          axis.plotLines.push(
            {
              value: moment().unix() * 1000,
              color: "#303f9f"
            }
          );
        }
        this.config.yAxis.push(axis);
        positionYaxis(this.config.yAxis);
        //reloadPositions(this.config);
        return this.config.yAxis.length - 1;
      }

      var addSerie = function(serie){



        if(serie.label == undefined || serie.label){
          serie.label = {
            onArea: false,
            connectorAllowed: true,
            connectorNeighbourDistance: 10,
          }
          serie.animation = {
            duration: 0
          }
        }


        if(ArrayHasData(serie.data)){
          this.config.series.push(serie);
        } else if(serie.type == "flags"){
          this.config.series.push(serie);
        }else{
          console.warn("serie "+serie.name+" no tiene datos");
        }
      }

      var getSerie = function(id){
        var r = null;
        _.each(this.config.series, function(serie){
          if(serie.id == id){
            r = serie
          }
        });
        return r;
      }

      var addSerieZone = function(zone){
        var serie = getSerie.bind(this)(zone.serieId);
        if(serie !== null){
          serie.zones.push(zone);
        }else{
          console.warn("addSerieZone: serie no encontrada");
        }
      }

      var addPlotLineY = function(plotLineY){
        var axis = plotLineY.yAxis || 1;
        if(this.config.yAxis[axis].plotLines == undefined){
          this.config.yAxis[axis].plotLines = [];
        }
        this.config.yAxis[axis].plotLines.push(plotLineY);
      }

      var addPlotBandY = function(plotBandY){
        var axis = plotBandY.yAxis || 1;
        if(this.config.yAxis[axis].plotBands == undefined){
          this.config.yAxis[axis].plotBands = [];
        }
        this.config.yAxis[axis].plotBands.push(plotBandY);
      }


      var addPlotLineX = function(plotLineX){
        //var axis = plotLineX.xAxis || 1;
        if(this.config.xAxis.plotLines == undefined){
          this.config.xAxis.plotLines = [];
        }
        this.config.xAxis.plotLines.push(plotLineX);
      }

      var addPlotBandX = function(plotBandY){
        var axis = plotBandY.xAxis || 1;
        if(this.config.xAxis[axis].plotBands == undefined){
          this.config.xAxis[axis].plotBands = [];
        }
        this.config.xAxis[axis].plotBands.push(plotBandY);
      }



      var getDeltas = function(arr){
        var deltas = [];
        //var unix   = arr[0][0];
        var hour   = 0;//moment(unix).hours();
        var min    = 0;//moment(unix).minutes();
        var r      = [];
        var last   = null;
        _.each(arr, function(item, i){
          if( moment(item[0]).utc().hours() == hour &&
            moment(item[0]).utc().minutes() == min){
            if(i > 0 && last !== null){
              r.push([item[0], Math.abs(item[1] - last)]);
            }
            last = item[1];
          }
        });
        return r;
      }


      var reloadIndex = function(indexId){

        var series      = chart.series;
        var seriesToSum = [];
        var seriesSum   = [];
        var dataSum     = [];
        var dataCount   = [];

        _.each(series, function(serie){
          if(serie.userOptions.indexId == indexId){
            seriesToSum.push(serie);
          }
          if(serie.userOptions.indexTo == indexId){
            seriesSum.push(serie);
          }
        });

        if(seriesToSum.length > 0){
          _.each(seriesSum, function(serie){
            if(serie.visible){
              _.each(serie.userOptions.data, function(d, i){
                if(dataCount[i] == undefined){
                  dataCount[i] = 0;
                }
                if(dataSum[i] === undefined){
                  dataSum[i] = [d[0], d[1]];
                }else{
                  dataSum[i] = [d[0], d[1] + dataSum[i][1]];
                }
                dataCount[i]++;
              });
            }
          });
          _.each(dataSum, function(ds, i){
            dataSum[i][1] = ds[1]/dataCount[i];
          })
          _.each(seriesToSum, function(serie){
            var d = getDeltas(dataSum);
            serie.setData(d, false);
          });
          chart.redraw();
        }
      }



      var getSerieBy = function(tagName, val, chartParam){
        var chart       = chartParam !== undefined ?  chartParam : chart;
        var series      = chart.series;
        var r     = [];
        _.each(series, function(serie){
          if(serie.userOptions[tagName] == val && serie.userOptions.group !== "nav"){
            r.push(serie);
          }
        });
        return r;
      }


      var reloadSum = function(sumId, chartParam, redraw){
        var chart       = chartParam !== undefined ?  chartParam : chart;
        var series      = chart.series;
        var seriesToSum = getSerieBy("sumId", sumId, chart); //items resultado
        var seriesSum   = getSerieBy("sumTo", sumId, chart); //items a sumar
        var dataSum     = [];
        var redraw      = redraw == undefined ? true : redraw;

        // _.each(series, function(serie){
        //   if(serie.userOptions.sumId == sumId){
        //     seriesToSum.push(serie);
        //   }
        //   if(serie.userOptions.sumTo == sumId){
        //     seriesSum.push(serie);
        //   }
        // });

        if(seriesToSum.length > 0){
          _.each(seriesSum, function(serie){
            if(serie.visible){
              _.each(serie.userOptions.data, function(d, i){
                if(dataSum[i] === undefined){
                  dataSum[i] = [d[0], d[1]];
                }else{
                  dataSum[i] = [d[0], d[1] + dataSum[i][1]];
                }
              });
            }
          });
          _.each(seriesToSum, function(serie){
            serie.setData(dataSum, false);
          });
          if(redraw){
            console.log("redraw reloadSum");
            chart.redraw();
          }
        }
      }

      var redraw = function(chartParam){
        var chart = chartParam !== undefined ?  chartParam : chart;
        chart.redraw();
      }





      var reloadProm = function(promId, chartParam, redraw){
        //prom == promedio
        var chart        = chartParam !== undefined ?  chartParam : chart;
        var series       = chart.series;
        var seriesToProm = getSerieBy("promId", promId, chart); //items resultado
        var seriesProm   = getSerieBy("promTo", promId, chart); //items a promediar
        var dataProm     = [];
        var countProm    = [];
        var redraw      = redraw == undefined ? true : redraw;

        if(seriesToProm.length > 0){
          _.each(seriesProm, function(serie){
            if(serie.visible){
              var data = serie.userOptions.data;
              if(serie.userOptions._data){
                data =  serie.userOptions._data;
              }
              _.each(data, function(d, i){
                if(dataProm[i] === undefined){
                  dataProm[i] = [d[0], d[1]];
                  countProm[i] = 1;
                }else{
                  dataProm[i] = [d[0], d[1] + dataProm[i][1]];
                  countProm[i]++;
                }
              });
            }
          });
          _.each(dataProm, function(d, i){
            d[1] = d[1]/countProm[i]
          });
          _.each(seriesToProm, function(serie){
            serie.setData(dataProm, false);
          });
          if(redraw){
            console.log("redraw reloadProm");
            chart.redraw();
          }
        }
      }






      var show = function(idElement){
        var config = this.getConfig();
        ID_ELEMENT = idElement;
        var rand   = _.random(0, 10000000);
        var el     = $("#"+ID_ELEMENT).find(class_subelement)[0];
        chart      = Highcharts.stockChart(el, config);


        $("#"+idElement).on("mouseup mouseleave", function(e){
          if(draggingId !== null){
            stop(e, chart);
          }
        });

        return chart;

      }

      var addTodayLine = function(){
        addPlotLineX.bind(this)({
          //color: "#5c6bc0",
          color: "#c5cae9",
          className:"today-line",
          label:{
            text:"Hoy",
            x: 0,
            y: 0,
            textAlign: "left",
            align:"left",
            verticalAlign: "top",
            className:"today-label",
            useHTML: true,
            rotation: 0
          },
          value: moment().unix() * 1000,
          width: 2,
          zindex:100
        });
      }

/* TODO
 * agregar eventos desde afuera
 * incluir funciones privadas
 * manejo de alturas para ejes agregados
 *
 *
 * */



      Irriview.prototype = {
        show                 : show,
        getConfig            : getConfig,
        getRelativePositions : getRelativePositions,
        addYAxis             : addYAxis,
        addSerie             : addSerie,
        addPlotLineY         : addPlotLineY,
        addPlotBandY         : addPlotBandY,
        addSerieZone         : addSerieZone,
        expandChart          : expandChart,
        reloadSum            : reloadSum,
        reloadProm           : reloadProm,
        reloadIndex          : reloadIndex,
        getDeltas            : getDeltas,
        getSerieBy           : getSerieBy,
        addTodayLine         : addTodayLine,
        ArrayHasData         : ArrayHasData,
        redraw               : redraw
      };

      return Irriview;



    }]);
})();
